import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { DataServiceService } from '../data-service.service';
import { Result } from '../model/result';

@Component({
  selector: 'app-result-nsl-entity',
  templateUrl: './result-nsl-entity.component.html',
  styleUrls: ['./result-nsl-entity.component.scss']
})
export class ResultNSLEntityComponent implements OnInit {

  chinese_string = ""
  isChineseSearch = localStorage.getItem("isChineseSearch");
  isChineseSearchBoolean: boolean;
  showSuccessMsg: boolean = false;
  isSavingRecord: boolean = false
  individualData = JSON.parse(localStorage.getItem('data'))

  constructor(
    private dataService: DataServiceService,
    private router: Router,
    private authService: AuthService,
    private location: Location
  ) { }

  goBack() {
    localStorage.setItem("skipSearchOnBack", "true");
    localStorage.setItem("skipSearchOnBackTs", Date.now().toString());
    this.location.back();
  }

  ngOnInit(): void {
    if(this.isChineseSearch == "true"){
      this.isChineseSearchBoolean = true;
      this.chinese_string = localStorage.getItem('chinese_string')
    }else{
      this.isChineseSearchBoolean = false;
    }
  }

  saveRecord(){
    this.isSavingRecord = true
    var currentDate = new Date()

    var historyObj = {}

    historyObj['userEmail'] = this.authService.getCurrentUser().email;
    
    this.individualData['saveDate'] = `${currentDate.getDate()}/${currentDate.getMonth()+1}/${currentDate.getFullYear()}`;
    this.individualData['saveTime'] = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    this.individualData['UTCsaveDate'] = `${currentDate.getUTCDate()}/${currentDate.getUTCMonth()+1}/${currentDate.getUTCFullYear()}`;
    this.individualData['UTCsaveTime'] = `${currentDate.getUTCHours()}:${currentDate.getUTCMinutes()}:${currentDate.getUTCSeconds()}`;
    this.individualData['type'] = 'NSL_ENTITY'

    historyObj['historyData'] = [this.individualData]

    this.dataService.saveSearchResult(historyObj)
    .then((data)=>{
      if(data['msg'] == 'Saved record'){
        this.isSavingRecord = false
        this.showSuccessMsg = true;
        setTimeout(() => {
          this.showSuccessMsg = false;
        }, 5000);
      }
      else{
        alert('Failed to save record. Please try after some time')
      }
    })
  }

}
